import styled, { css } from 'styled-components'

import { Array } from '@blade/std-lib'
import {
  ActivePremiumListItemSkeleton,
  ExpiredPremiumListItemSkeleton,
} from '@root/entities/premium/ui/desktop'
import { InfoMessage } from '@root/shared/ui-kit'

import type { UserPremiumTab } from '../../premium-tabs'

type UserPremiumListErrorProps = {
  onRetry: () => void
  placement?: 'profile' | 'premium'
  tab?: UserPremiumTab
}

export const UserPremiumListError: React.FC<UserPremiumListErrorProps> = ({
  onRetry,
  placement,
  tab,
}) => {
  if (placement === 'profile') {
    return (
      <Root>
        <InfoMessage
          intent="error"
          variant="dt"
          onRetry={onRetry}
          withBackground
        />
      </Root>
    )
  }

  const SkeletonCmp =
    tab === 'active'
      ? ActivePremiumListItemSkeleton
      : ExpiredPremiumListItemSkeleton

  return (
    <Root>
      <InfoContainer>
        <InfoMessage
          intent="error"
          variant="dt"
          onRetry={onRetry}
          css={css`
            z-index: 1;
          `}
        />
      </InfoContainer>
      <Background>
        {Array.range(1, 10).map((it) => (
          <SkeletonCmp key={it} disabled />
        ))}
      </Background>
    </Root>
  )
}

const Root = styled.div`
  display: grid;
  position: relative;
`

const Background = styled.div`
  position: absolute;
  left: 0;
  top: 3px;
  bottom: 0;
  width: 100%;

  display: grid;
  padding: 12px;
  align-items: start;
  gap: 10px;
  align-content: flex-start;

  &::after {
    content: '';

    background: linear-gradient(0deg, var(--appearance-1) 0%, transparent 100%);

    position: absolute;
    bottom: 0;
    left: 0;
    top: 0;
    width: 100%;
  }
`

const InfoContainer = styled.div`
  display: grid;
`
